// extracted by mini-css-extract-plugin
export default {"container":"BackArrow_container__DqYAq","row":"BackArrow_row__pRJvk","text":"BackArrow_text__kY6ZY"};